document.querySelector('[data-js-scroll-positions]')?.addEventListener('click', () => {
    const jobsList = document.getElementById('jobs-list');

    if (jobsList !== null) {
        jobsList?.scrollIntoView();
    }
});

export {};
